import { PIPEFITTER_SET_INVALID_FILES } from './types';

const initialState = {
  invalidFiles: [],
};

export default function pipefitterUploadsReducer(state = initialState, action) {
  switch (action.type) {
    case PIPEFITTER_SET_INVALID_FILES:
      return { ...state, invalidFiles: action.payload };
    default:
      return state;
  }
}
